module.exports = __webpack_public_path__ + "img/empty-list-projects.bdb4e04f.svg";